export default "__VITE_ASSET__Cp_fNzuV__"